module.exports = __webpack_public_path__ + "static/img/14000422.da57eedb.png";